export const ContactsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="4" y="1" width="19" height="22" strokeWidth="1.67" />
      <path d="M4 5L1 5" strokeWidth="2" />
      <path d="M4 12H1" strokeWidth="2" />
      <path d="M3 19H1" strokeWidth="2" />
      <circle cx="13.5" cy="8.5" r="3.5" strokeWidth="1.67" />
      <path
        d="M22 22.0345C20.7743 18.5209 17.4315 16 13.5 16C9.56846 16 6.22571 18.5209 5 22.0345"
        strokeWidth="1.67"
      />
    </svg>
  );
};
